<template>
  <div>
    <div
      class="btn-group btn-group-toggle"
      data-toggle="buttons"
      :style="input.disabled || input.readonly ? 'pointer-events: none;' : ''"
    >
      <label v-for="item in input.options" class="btn" v-bind:key="item.value">
        <input
          type="checkbox"
          :checked="input.value.indexOf(item.value) > -1"
          :name="input.name"
          autocomplete="off"
          :value="item.value"
          @change="handleChange"
        />{{ item.label }}
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputCheckbox",
  components: {},
  props: {
    input: Object,
  },
  data: function() {
    return {};
  },
  methods: {
    handleChange(e) {
      this.$emit("handleChange", e);
    },
  },
};
</script>
